import { ApiClient } from 'services/ApiService'

export const getNewsList = (payload: any) =>
  ApiClient.get('/customer/banner/new', payload)
export const getNewsDetail = (id: number) =>
  ApiClient.get(`/customer/banner/${id}/new`)
